// src/screens/TipBucket/TipBucketScreen.js
import React, { useState, useEffect, useContext } from 'react';
import CountContext from '../../context/CountContext.js';

export default function TipBucketScreen({ onNext, onBack }) {
  const { state, dispatch } = useContext(CountContext);
  const { coins } = state.tipBucket;
  const { tipRounding } = state.thresholds;
  // — NEW: local state for editable tip‐bucket inputs
  const [coinInput, setCoinInput] = useState(
    state.tipBucket.coins.toFixed(2)
  );
  const [billInput, setBillInput] = useState(
    state.tipBucket.bills.toFixed(2)
  );

  // — NEW: keep local inputs in sync if context updates elsewhere
  useEffect(() => {
    setCoinInput(state.tipBucket.coins.toFixed(2));
  }, [state.tipBucket.coins]);

  useEffect(() => {
    setBillInput(state.tipBucket.bills.toFixed(2));
  }, [state.tipBucket.bills]);
  // — NEW: helper to clean input strings (digits + one dot, max 2 decimals)
  const sanitizeStr = (value) => {
    let clean = value.replace(/[^0-9.]/g, '');
    const parts = clean.split('.');
    if (parts.length > 2) clean = parts[0] + '.' + parts.slice(1).join('');
    if (parts[1]?.length > 2) clean = parts[0] + '.' + parts[1].slice(0, 2);
    return clean;
  };


  const handleConfirm = () => {
    // compute removal only once here
    const fractional = coins - Math.floor(coins);
    const removal =
      fractional >= tipRounding ? Math.ceil(coins) : Math.floor(coins);
    dispatch({ type: 'SET_TIP_DRAWER_REMOVAL', payload: removal });
    onNext();
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Step: Tip-Bucket Count</h2>

      <div className="mb-6">
        <label className="block mb-1">Tip‑Bucket Coins ($):</label>
        <input
          type="text"
          className="border rounded p-1 w-24"
          value={coinInput}
          onChange={e => setCoinInput(sanitizeStr(e.target.value))}
          onBlur={() =>
            dispatch({
              type: 'UPDATE_TIP_BUCKET_COINS',
              payload: parseFloat(coinInput) || 0,
            })
          }
          onFocus={e => e.target.select()}
        />
      </div>


      <div className="mb-6">
        <label className="block mb-1">Tip-Bucket Bills ($):</label>
        <input
          type="text"
          className="border rounded p-1 w-24"
          value={billInput}
          onChange={e => setBillInput(sanitizeStr(e.target.value))}
          onBlur={() =>
            dispatch({
              type: 'UPDATE_TIP_BUCKET_BILLS',
              payload: parseFloat(billInput) || 0,
            })
          }
          onFocus={e => e.target.select()}
        />

      </div>

      <div className="flex justify-between">
        <button
          className="px-4 py-2 bg-gray-300 rounded"
          onClick={onBack}
        >
          Back
        </button>
        <button
          className="px-4 py-2 bg-blue-500 text-white rounded"
          onClick={handleConfirm}
        >
          Confirm Tip-Bucket
        </button>
      </div>
    </div>
  );
}
